<script setup lang="ts">
import { computed } from "vue";
import { type IconName, icons } from "./iconData";

interface Props {
  name: IconName;
  size?: number | string;
  strokeWidth?: number;
  label?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  strokeWidth: 2,
  label: undefined,
});

const icon = computed(() => icons[props.name]);
const isStroke = computed(() => icon.value.style === "stroke");
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    :fill="isStroke ? 'none' : 'currentColor'"
    :stroke="isStroke ? 'currentColor' : undefined"
    :stroke-width="isStroke ? strokeWidth : undefined"
    :stroke-linecap="isStroke ? 'round' : undefined"
    :stroke-linejoin="isStroke ? 'round' : undefined"
    :aria-hidden="!label"
    :aria-label="label"
    role="img"
  >
    <template v-for="(path, index) in icon.paths" :key="index">
      <path v-if="path.type === 'path'" :d="path.d" />
      <circle
        v-else-if="path.type === 'circle'"
        :cx="path.cx"
        :cy="path.cy"
        :r="path.r"
      />
      <line
        v-else-if="path.type === 'line'"
        :x1="path.x1"
        :y1="path.y1"
        :x2="path.x2"
        :y2="path.y2"
      />
      <rect
        v-else-if="path.type === 'rect'"
        :x="path.x"
        :y="path.y"
        :width="path.width"
        :height="path.height"
        :rx="path.rx"
      />
    </template>
  </svg>
</template>
